import React from 'react';
import styles from './PricingHeader.module.css';

const PricingHeader = () => (
  <header className={styles.heading}>
    Set default price for articles
    {/* <hr /> */}
  </header>
);

export default PricingHeader;
